//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Icon } from 'vant'

export default {
  name: 'CCircleMenu',

  components: { Icon },

  props: {
    startAngle: {
      type: Number,
      default: 0,
    },

    endAngle: {
      type: Number,
      default: 360,
    },

    position: {
      type: Object,
      default: () => {
        return {
          right: '3.12500rem',
          bottom: '3.12500rem',
        }
      },
    },

    list: {
      type: Array,
      default: () => {
        return [
          {
            // title: '返回',
            icon: 'point-gift-o',
            handler: () => {
              alert(0)
            },
          },
          { title: '个人中心2' },
          { title: '个人中心3' },
          { title: '个人中心4' },
          { title: '个人中心5' },

          // { title: '2' },
          // { title: '2' },
        ]
      },
    },
  },

  data () {
    return {
      isOpen: false,
      centerStyle: {},
      lineStyle: {
        width: '1.00000rem',
        top: '50%',
      },
      line1Style: {},
      line3Style: {},
    }
  },

  computed: {
    menuList: {
      set (value) {
        this.$emit('input', value)
      },
      get () {
        this.list.forEach((el, idx) => {
          this.$set(el, 'cssObj', {})
        })

        return this.list
      },
    },
  },

  methods: {
    toggleMenu () {
      const angleDiff = this.endAngle - this.startAngle
      const radius = this.$refs.circleMenu.clientHeight / 2
      const num = angleDiff <= 180 ? -1 : 0

      if (!this.isOpen) {
        this.centerStyle = {
          width: '1.87500rem',
          height: '1.87500rem',
        }
        this.line1Style = {
          ...this.lineStyle,
          transform: 'rotate(45deg)',
        }
        this.line3Style = {
          ...this.lineStyle,
          transform: 'rotate(-45deg)',
        }

        this.menuList.forEach((el, idx) => {
          const deg = parseInt(angleDiff / (this.menuList.length + num)) * (idx) + this.startAngle

          // console.log(111, deg)
          const x = Math.sin(2 * Math.PI / 360 * deg) * radius + radius
          const y = Math.cos(2 * Math.PI / 360 * deg) * radius + radius
          const time = 80 * (parseInt(idx / 2) + 1)
          el.cssObj = {
            transitionDuration: `${time}ms`,
            left: `${x}px`,
            top: `${y - 20}px`,
          }

          setTimeout(() => {
            el.cssObj = {
              transitionDuration: `${time}ms`,
              left: `${x}px`,
              top: `${y}px`,
            }
          }, 100)
        })

        this.isOpen = true
      } else {
        this.centerStyle = {}

        this.menuList.forEach((el, idx) => {
          el.cssObj = {}
        })

        this.line1Style = {}
        this.line3Style = {}
        this.isOpen = false
      }
    },
  },
}
